"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerSalesOrdersContext = void 0;
const React = require("react");
/**
 * Provides the customers SalesOrders
 */
exports.CustomerSalesOrdersContext = React.createContext({
    outstandingSalesOrders: undefined,
    pastSalesOrdersPageNumber: undefined,
    setPastSalesOrdersPageNumber: undefined,
    pastSalesOrders: undefined,
    isLoadingPastSalesOrdersFetch: undefined,
    errorPastSalesOrdersFetch: undefined,
    loadMorePastSalesOrders: undefined,
    allSalesOrders: undefined
});
//# sourceMappingURL=index.js.map